import dayjs from "dayjs";
import { clsx, ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import CryptoJS from "crypto-js";

export const formattedDate = (date: string) => {
  return dayjs(date).format("DD/MM/YYYY");
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getFileExtension = (mimeType: string): string => {
  const mimeToExt: Record<string, string> = {
    "image/jpeg": "jpeg",
    "image/jpg": "jpg",
    "image/png": "png",
    "application/pdf": "pdf",
    "text/csv": "csv",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  };

  return mimeToExt[mimeType] || "";
};

const SECRET_KEY = "bWosul6HxVwCp";

export const encryptData = (data: any): string => {
  const dataString =
    typeof data === "object" ? JSON.stringify(data) : String(data);

  const encrypted = CryptoJS.AES.encrypt(dataString, SECRET_KEY);
  return encrypted.toString();
};

export const decryptData = (encryptedData: string): any => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) {
      console.error("Decryption failed - likely wrong key or corrupted data");
      return null;
    }

    try {
      return JSON.parse(decrypted);
    } catch (e) {
      return decrypted;
    }
  } catch (e) {
    console.error("Decryption error:", e);
    return null;
  }
};
